import { getSessionStorageSearchState } from '@/utils/search/searchState'
import {
  DEFAULT_DISTANCE_INDEX,
  DISTANCE_OPTIONS_LOCATION_TYPE_MAPPING,
  DEFAULT_LOCATION_TYPE
} from '../filterOptions/constants'
import { getLocaleDistanceOptions } from '@/utils/search/getLocaleDistanceOptions'
import { generateAlgoliaConfigurationFromSearchState } from '@/utils/search/generateAlgoliaConfigurationFromSearchState'
import { SortByType } from './constants'

const refineSearchByGeolocation = async ({
  locationName,
  locationType,
  geoLocation,
  location = {}
}) => {
  const coords = geoLocation.geometry.location

  const searchStateFromSessionStorage = getSessionStorageSearchState()

  const customRadius = location.miRadius

  let distanceOptionIndex = DEFAULT_DISTANCE_INDEX
  for (const distanceOption in DISTANCE_OPTIONS_LOCATION_TYPE_MAPPING) {
    if (distanceOption === locationType) {
      distanceOptionIndex =
        DISTANCE_OPTIONS_LOCATION_TYPE_MAPPING[distanceOption]
      break
    }
  }

  const distanceOption = getLocaleDistanceOptions()[distanceOptionIndex]

  const refinedSearchState = {
    refinementList: {
      ...searchStateFromSessionStorage.refinementList,
      locations: []
    },
    aroundLatLng: `${coords.lat},${coords.lng}`,
    locationName: locationName,
    locationType: locationType || DEFAULT_LOCATION_TYPE,
    sortBy: SortByType.Relevance,
    configure: {
      aroundLatLng: `${coords.lat},${coords.lng}`,
      aroundRadius: distanceOption.meters,
      aroundPrecision: distanceOption.meters
    }
  }
  if (customRadius && customRadius > 0) {
    refinedSearchState.customLocationRadiusInMiles = customRadius
  }
  const configure = generateAlgoliaConfigurationFromSearchState(
    refinedSearchState,
    {
      aroundRadius: distanceOption.meters,
      modifyFilters: true
    }
  )

  return {
    ...refinedSearchState,
    configure
  }
}

export default refineSearchByGeolocation
